import { contactIconList } from "@/lib/data";
import { BuilderOptions } from "../index";

export const otherLocationsConfig = {
  name: "Other Locations",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "other-locations",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      required: true,
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      helperText: "Additional CSS classes for the section",
      advanced: true,
    },
    {
      name: "heading",
      friendlyName: "Heading",
      type: "string",
      defaultValue: "Other Locations",
      helperText: "Main heading for the section",
      required: true,
    },
    {
      name: "locations",
      type: "list",
      max: 4,
      helperText: "List of locations to display",
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Location Title",
          required: true,
        },
        {
          name: "items",
          type: "list",
          friendlyName: "Location Details",
          max: 4,
          onChange: (options: BuilderOptions) => {
            if (options.get("items").length > 4) {
              options.set("items", options.get("items").slice(0, 4));
              alert("Maximum Location Detail is 4");
            }
          },
          subFields: [
            {
              name: "icon",
              type: "string",
              enum: contactIconList,
              friendlyName: "Icon",
              helperText: "Icon name for the detail item",
            },
            {
              name: "text",
              type: "string",
              friendlyName: "Text",
              helperText: "Text for the detail item",
            },
            {
              name: "href",
              type: "string",
              friendlyName: "Link",
              helperText: "Link for the detail item",
            },
          ],
        },
        {
          name: "button",
          type: "object",
          friendlyName: "Button",
          subFields: [
            {
              name: "color",
              type: "string",
              friendlyName: "Button Color",
              helperText: "Color of the button",
            },
            {
              name: "children",
              type: "string",
              friendlyName: "Button Text",
              helperText: "Text displayed on the button",
            },
          ],
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Link",
          helperText: "URL for the button link",
        },
      ],
      defaultValue: [
        {
          title: "San Francisco",
          items: [
            {
              icon: "map-pin",
              text: "50 California Street, Suite 1500, San Francisco, CA 94111",
              href: "https://maps.google.com/?q=50+California+Street,+Suite+1500,+San+Francisco,+CA+94111",
            },
            {
              icon: "phone",
              text: "(650) 328-1001",
              href: "tel:(650) 328-1001",
            },
            {
              icon: "mail",
              text: "info@careindeed.com",
              href: "mailto:info@careindeed.com",
            },
            { icon: "clock", text: "9:00 AM - 5:30 PM" },
          ],
          button: {
            color: "orange",
            children: "Reach Out to Us",
          },
          href: "/contact-us",
        },
        {
          title: "Walnut Creek",
          items: [
            {
              icon: "map-pin",
              text: "2121 North California Blvd., Suite 290, Walnut Creek, CA 94596",
            },
            { icon: "phone", text: "(650) 328-1001" },
            { icon: "mail", text: "info@careindeed.com" },
            { icon: "clock", text: "9:00 AM - 5:30 PM" },
          ],
          button: {
            color: "orange",
            children: "Reach Out to Us",
          },
          href: "/contact-us",
        },
        {
          title: "San Mateo",
          items: [
            {
              icon: "map-pin",
              text: "102 S El Camino Real, San Mateo, CA 94401",
            },
            { icon: "phone", text: "(650) 328-1001" },
            { icon: "mail", text: "info@careindeed.com" },
            { icon: "clock", text: "9:00 AM - 5:30 PM" },
          ],
          button: {
            color: "orange",
            children: "Reach Out to Us",
          },
          href: "/contact-us",
        },
        {
          title: "Palo Alto",
          items: [
            {
              icon: "map-pin",
              text: "228 Hamilton Avenue 3rd Floor Palo Alto CA 94301",
            },
            { icon: "phone", text: "(650) 328-1001" },
            { icon: "mail", text: "info@careindeed.com" },
            { icon: "clock", text: "9:00 AM - 5:30 PM" },
          ],
          button: {
            color: "orange",
            children: "Reach Out to Us",
          },
          href: "/contact-us",
        },
      ],
    },
  ],
};
